import React, { useState, useEffect } from 'react';
import moment from 'moment';

const DmsDashboardHeader = (props) => {
    const { bucketData, themeSelected } = props;
    const [headerData, setHeaderData] = useState([]);

    useEffect(() => {
        if (bucketData && bucketData.length > 0) {
            processHeaderData();
        }
    }, [bucketData]);

    const processHeaderData = () => {
        // Filter active buckets - handle both boolean and Buffer format
        const activeBuckets = bucketData.filter(bucket => {
            if (bucket.Status && bucket.Status.data && Array.isArray(bucket.Status.data)) {
                return bucket.Status.data[0] === 1;
            }
            // Handle boolean format from GraphQL
            return Boolean(bucket.Status);
        });

        // Group data by time slots (9:00 AM, 10:00 AM, etc.)
        const timeSlots = {};
        
        activeBuckets.forEach(bucket => {
            const startTime = bucket.StartTime ? moment(bucket.StartTime, "HH:mm:ss").format("h:mm A") : null;
            const endTime = bucket.EndTime ? moment(bucket.EndTime, "HH:mm:ss").format("h:mm A") : null;
            
            if (startTime) {
                if (!timeSlots[startTime]) {
                    timeSlots[startTime] = {
                        time: startTime,
                        endTime: endTime,
                        under1hr: 0,
                        over1hr: 0,
                        over1_5hr: 0
                    };
                }
                
                // Aggregate count data from buckets
                if (bucket.count) {
                    timeSlots[startTime].under1hr += bucket.count.under_1_hr || 0;
                    timeSlots[startTime].over1hr += bucket.count.over_1_hr || 0;
                    timeSlots[startTime].over1_5hr += bucket.count.over_1_5_hr || 0;
                }
            }
        });

        // Convert to array and sort by time
        const headerArray = Object.values(timeSlots).sort((a, b) => {
            return moment(a.time, "h:mm A").diff(moment(b.time, "h:mm A"));
        });

        // Show all items - scrolling will be handled by CSS
        setHeaderData(headerArray);
    };

    return (
        <div className="dms-dashboard-header">
            {headerData.map((item, index) => (
                <div key={index} >
                    <div className="dms-dashboard-card">
                        <div className="dms-dashboard-card-time">
                            {item.time}{item.endTime ? ` - ${item.endTime}` : ''}
                        </div>
                        <div className="dms-dashboard-card-badges">
                            <div className="dms-dashboard-badge green">
                                <span className="badge-count">{item.under1hr}</span>
                                <span className="badge-label">Under 1hr</span>
                            </div>
                            <div className="dms-dashboard-badge orange">
                                <span className="badge-count">{item.over1hr}</span>
                                <span className="badge-label">Over 1hr</span>
                            </div>
                            <div className="dms-dashboard-badge red">
                                <span className="badge-count">{item.over1_5hr}</span>
                                <span className="badge-label">Over 1.5hr</span>
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default DmsDashboardHeader;